<template>
  <div>

  <!-- <header class="main-header">
  		<nav class="navbar navbar-expand-md bg-3">

  			<div class="navbar-options px-3 px-md-4">
  				<div class="form search-form mr-auto">
  					<div class="form-group mb-0 d-flex position-relative">
  						<input
              v-on:keyup.enter="search"
               type="text" class="form-control pl-5" placeholder="Search for..." />
  						<button type="submit" class="btn btn-link pl-0 pt-2">
  							<i class="pe pe-7s-search pe-2x"></i>
  						</button>
  					</div>
  				</div>

  				<ul class="nav">

  					<li class="aside-toggler" data-behavior="absolute">
  						<a href="javascript:;" v-on:click="aside">
  							<i class="pe pe-7s-keypad"></i>
  						</a>
  					</li>
  				</ul>
  			</div>
  		</nav>
  	</header> -->
    <div class="main-body">
      <a class="menu" href="javascript:;" v-on:click="aside">
        <i class="pe pe-7s-keypad"></i>
      </a>


    <!-- stuff comes here -->
    <router-view></router-view>


    <aside class="quick-view absolute">
    			<div class="side-wrapper">
    				<nav class="nav nav-tabs nav-fill tabs-clean slide">
    					<a class="nav-item nav-link active" data-toggle="tab" href="#aside-todo" data-rel="todos">
    						<i class="fas fa-list-ul icon"></i>
    					</a>
    					<a class="nav-item nav-link" data-toggle="tab" href="#aside-settings">
    						<i class="fas fa-cog icon"></i>
    					</a>
    				</nav>
    				<div class="tab-content">
    					<div class="tab-pane active" id="aside-todo">
                <div class="nav-wrapper">
        					<ul class="nav flex-column">
                    <li class="nav-item">
                      <router-link to="/items/data" class="nav-link" v-on:click.native="aside">
                        <i class="icon fas fa-box"></i>
                        <span class="title">Items</span>
                      </router-link>
                    </li>
					  <li class="nav-item">
						<router-link to="/products/feed" class="nav-link" v-on:click.native="aside">
						  <i class="icon fas fa-chart-line"></i>
						  <span class="title">Product Feed</span>
						</router-link>
					  </li>
                    <li v-if="Data.featureEnabled('script',Data)" class="nav-item">
                      <router-link to="/scripts" class="nav-link"  v-on:click.native="aside">
                        <i class="icon fas fa-sync-alt"></i>
                        <span class="title">Scripts</span>
                      </router-link>
        						</li>
                    <li v-if="Data.featureEnabled('user',Data)" class="nav-item">
                      <router-link to="/users" class="nav-link" v-on:click.native="aside">
                        <i class="icon fas fa-user"></i>
                        <span class="title">Users</span>
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <a href="javascript:;" class="nav-link" v-on:click="logout">
                        <i class="icon fas fa-sign-out-alt"></i>
                        <span class="title">Logout</span>
                      </a>
                    </li>
                  </ul>
                </div>
    					</div>
    					<div class="tab-pane" id="aside-settings">
    						<ul class="list-group list-group-flush">
    							<li class="list-group-item px-0">
    								<h4 class="small bold mb-4">Email settings</h4>
    								<div class="mb-3 d-flex justify-content-between align-items-center">
    									<div class="mr-3">
    										<p class="regular mb-0 color-5">Automatic response</p>
    										<p class="color-2 mb-0 small">(Experimental) Configure an automated response</p>
    									</div>
    									<div class="form-group mb-0">
    										<input class="tgl tgl-light" id="tgl-1" type="checkbox">
    										<label class="tgl-btn tgl-btn-4" for="tgl-1"></label>
    									</div>
    								</div>
    								<div class="mb-3 d-flex justify-content-between align-items-center">
    									<div class="mr-3">
    										<p class="regular mb-0 color-5">Daily summary emails</p>
    										<p class="color-2 mb-0 small">Send me a daily summary of all my activity</p>
    									</div>
    									<div class="form-group mb-0">
    										<input class="tgl tgl-light" id="tgl-2" type="checkbox" checked="checked">
    										<label class="tgl-btn tgl-btn-4" for="tgl-2"></label>
    									</div>
    								</div>
    							</li>
    							<li class="list-group-item px-0">
    								<h4 class="small bold mb-4">Personal settings</h4>
    								<div class="mb-3 d-flex justify-content-between align-items-center">
    									<p class="regular mb-0 color-5 mr-3">Other can view my status</p>
    									<div class="form-group mb-0">
    										<input class="tgl tgl-light" id="tgl-3" type="checkbox">
    										<label class="tgl-btn tgl-btn-4" for="tgl-3"></label>
    									</div>
    								</div>
    								<div class="mb-3 d-flex justify-content-between align-items-center">
    									<p class="regular mb-0 color-5 mr-3">Allow remote access</p>
    									<div class="form-group mb-0">
    										<input class="tgl tgl-light" id="tgl-4" type="checkbox" checked="checked">
    										<label class="tgl-btn tgl-btn-4" for="tgl-4"></label>
    									</div>
    								</div>
    								<div class="mb-3 d-flex justify-content-between align-items-center">
    									<p class="regular mb-0 color-5 mr-3">Automatic signing</p>
    									<div class="form-group mb-0">
    										<input class="tgl tgl-light" id="tgl-5" type="checkbox">
    										<label class="tgl-btn tgl-btn-4" for="tgl-5"></label>
    									</div>
    								</div>
    								<div class="mb-3 d-flex justify-content-between align-items-center">
    									<p class="regular mb-0 color-5 mr-3">Clear cache on log off</p>
    									<div class="form-group mb-0">
    										<input class="tgl tgl-light" id="tgl-6" type="checkbox" checked="checked">
    										<label class="tgl-btn tgl-btn-4" for="tgl-6"></label>
    									</div>
    								</div>
    							</li>
    						</ul>
    					</div>
    				</div>
    			</div>
          <h2>PCMONDE</h2>
    		</aside>
        <div class="aside-overlay" v-on:click="aside"></div>

  </div>
</div>

</template>

<script>
import _ from 'lodash';
import Data from '../main';

export default {
	name: 'frame',
	computed: {
		Data() {
			return Data;
		},
	},
	methods: {
		logout: function() {
			this.$cookies.remove('user_session');
			this.$root.$emit('is_loggedin', false);
		},
		aside: function() {
			document.body.classList.toggle('quick-view-expanded');
			document.body.classList.toggle('is-absolute');
		},
	},
};
</script>

<style>
.main-body{
  all: unset !important;
}

body .main-body main .content{
  padding: 0;
}
.display-4 {
    font-size: 2.5rem !important;
    padding: 10px 0 0 10px;
}

.table-clean tr:hover{
  background: rgba(0,0,0,0.02);
}

.table-clean thead tr th {
    font-weight: 700;
    letter-spacing: normal;
    padding: 10px 4px;
    font-size: .7rem;
    background: rgba(0,0,0,0.02);
}
.multiselect__tags{
  min-height: 38px !important;
}

.input.disabled,
.input .disabled{
	cursor:not-allowed;
}
body .main-body .quick-view.absolute{
	z-index:10;
}
body.quick-view-expanded.is-absolute .aside-overlay{
	z-index:5;
}

</style>
<style scoped>
h2{
  font-weight: 800;
  text-align: center;
  position: absolute;
  bottom: 10px;
  width: 100%;
}
.menu{
  font-size: 24px;
  padding: 15px 14px 14px 22px;
  position: absolute;
  z-index: 1;
}
</style>
